import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const useSessionTimeout = (timeoutMinutes = 60) => {
  const navigate = useNavigate();

  useEffect(() => {
    const checkSession = () => {
      const loginTime = localStorage.getItem('loginTime');
      const token = localStorage.getItem('token');

      if (!loginTime || !token) {
        return;
      }

      const loginDate = new Date(loginTime);
      const now = new Date();
      const diffMinutes = (now - loginDate) / (1000 * 60);

      if (diffMinutes >= timeoutMinutes) {
        // Session expired
        toast.info('Session expired. Please login again.');
        localStorage.removeItem('token');
        localStorage.removeItem('loginTime');
        navigate('/LoginPage');
      }
    };

    const interval = setInterval(checkSession, 60000); // check every 1 minute

    return () => clearInterval(interval); // cleanup on unmount
  }, [navigate, timeoutMinutes]);
};

export default useSessionTimeout;
